import SmallPopupTemplate from "components/templates/modal/small/SmallPopupTemplate";
import * as s from "./ScreenRecorderExceptionStyled";
import { detect } from "detect-browser";
import useApiError from "hook/useApiError";
import { useMemo } from "react";

type ScreenRecorderExceptionType = {
  error: string;
  onFinish: () => void;
};

export function ScreenRecorderException({
  error,
  onFinish,
}: ScreenRecorderExceptionType) {
  const { lang, intlString } = useApiError();
  const errorKey =
    lang.screenRecordingError[error as keyof typeof lang.screenRecordingError];
  const errorTitle = errorKey?.title ? intlString(errorKey.title) : "";
  const errorDescription = useMemo(() => {
    if (!errorKey?.description) return "";
    if (typeof errorKey.description === "string") {
      return intlString(errorKey.description);
    }
    const browser = detect();
    if (browser && browser.name) {
      return intlString(
        errorKey.description[browser.name as keyof typeof errorKey.description]
      );
    }
  }, [errorKey, intlString]);

  return (
    <SmallPopupTemplate
      title={errorTitle}
      onClick={onFinish}
      onModal={onFinish}
      confirmLabel="OK"
      data-testid="blocks-screenrecorder-small-popup-template-finish"
    >
      <s.ErrorMessage>{errorDescription}</s.ErrorMessage>
    </SmallPopupTemplate>
  );
}
